<template lang="html">
<div>
  <div v-if="ordersList" class="order-list__countent">
    <van-list v-model="listLoading" :finished="listFinished" @load="onLoadMore" loading-text="努力加载中...">
    <manage-order-item class="bcw mtm" v-for="(item,index) in ordersList" :key="item.id" :order="item"></manage-order-item>
  </van-list>
  </div>
  <div v-else class="tac norecord">
      <i class="iconfont">&#xe646;</i><br/>
      暂无记录
  </div>
</div> 
</template>

<script>
import Vue from 'vue'
import ManageOrderItem from '@/components/ManageOrderItem'
import { List } from 'vant';
Vue.use(List);
export default {
  data(){
    return {
      ordersList:[], // 订单列表
      sta:[],  //订单分类
      listLoading: false,
      listFinished: false,
      page: 1,
      pageSize: 15
    }
  },
  components: {
    ManageOrderItem
  },
  methods: {
    loadOrders(status){
      // 取订单列表
      // let sta = [];
      if('refund' == status){
        this.sta = ['refunding','refunded'];
      }else if('false' == status){
        this.sta = [];
      }else{
        this.sta = [status];
      }

      this.$http.post('order_manage/getList',{
        status: JSON.stringify(this.sta),
        page:1,
        limit:this.pageSize
      }).then(res=>{
        if(!res.data.code){
          let re = res.data.value
          this.ordersList = re.data
        }else{
          alert(res.data.message)
        }
      })
    },
    onLoadMore() {
      // console.log('加载更多');      
      this.getList();
    },
    getList(){ 
      // console.log('传参page:',this.page)     
      //获取数据      
      this.$http.post('order_manage/getList',{
        status: JSON.stringify(this.sta),
        page:this.page,
        limit:this.pageSize
      }).then(res=>{
        if(!res.data.code){
          let re = res.data.value
          if(re.total>0){            
            // console.log(res)
            // console.log('length:',re.data.length)          
            
            this.listLoading = false;
            
            if (re.data.length < this.pageSize) {
              this.listFinished = true;
            }
            
            
            // console.log('最终page:',this.page)
            if(this.page==1){
              this.ordersList = re.data
            }
            if(this.page!==1 && this.ordersList.length<re.total){//拼接数据
              // console.log('拼接数据')
              this.ordersList = this.ordersList.concat(re.data)
            }
            // console.log(this.ordersList)
            this.page++
          }
        }else{
          this.listFinished = true;
        }
      })
    }
  },
  created(){
    this.loadOrders(this.$route.params.status)
  },
  beforeRouteUpdate (to, from, next) {
    this.loadOrders(to.params.status)
    this.page=1
    this.ordersList=[]
    this.listLoading=false
    this.listFinished=false
    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ManageOrderListRepeat.vue